import React from 'react'
import "../styles/CustomLoadingIndicator.css"
import { Loader } from 'rsuite'

export const CustomLoadingIndicator = () => {
   return (
      <Loader speed={'fast'} backdrop content="loading data ..." vertical />
   )
}
